__turbopack_context__.v({
  "skylinesFigure": "AboutMe-module__hTuR-G__skylinesFigure",
  "skylinesImage": "AboutMe-module__hTuR-G__skylinesImage",
  "video": "AboutMe-module__hTuR-G__video",
  "videoCopy": "AboutMe-module__hTuR-G__videoCopy",
  "videoWrapper": "AboutMe-module__hTuR-G__videoWrapper",
});
